// extracted by mini-css-extract-plugin
export var box = "_54-1";
export var checkboxRow = "_54-8";
export var checked = "_54-2";
export var descriptionSpacer = "_54-a";
export var disabled = "_54-3";
export var icon = "_54-6";
export var input = "_54-0";
export var labelSpacer = "_54-9";
export var medium = "_54-5";
export var small = "_54-4";
export var text = "_54-7";